import { render, staticRenderFns } from "./FavoritePosts.vue?vue&type=template&id=9d5d26e0&"
import script from "./FavoritePosts.vue?vue&type=script&lang=js&"
export * from "./FavoritePosts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports